import { render, staticRenderFns } from "./ClaimConfirm.vue?vue&type=template&id=236df898"
import script from "./ClaimConfirm.vue?vue&type=script&lang=ts"
export * from "./ClaimConfirm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports